export default __webpack_public_path__ + "static/media/rupee-white 1.86f2d9c6.svg";